import React from 'react';

function Footer() {
    return <div className="Footer">Created by Julie Schaub, University of Kansas Full Stack Boot Camp, October 2020</div>
}

export default Footer;